/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsCart = {
  init: function ($section) {

    // Add settings from schema to current object
    //Shopify.theme.jsCart = $.extend(this, Shopify.theme.getSectionData($section));

    this.$section = $section;

    $(document).on('click', '[data-cart-page-delete]', function (e) {
      e.preventDefault();
      const lineID = $(this).data('line-item-key');
      Shopify.theme.jsCart.removeFromCart(lineID);

      return false;
    });

    // Prevent the ajax cart form from being submitted when pressing the "Enter" key
    $('#cart_form').keydown(function(e){
      if (e.keyCode == 13) {
        e.preventDefault();
        return false;
      }
    });
  },
  removeFromCart: function (lineID) {
    const $cartItem = Shopify.theme.jsCart.$section.find(`[data-line-item="${lineID}"]`);

    $cartItem.css('opacity', '0.5');

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {

        $cartItem.addClass('animated zoomOut')
        $cartItem.remove();

        Shopify.theme.jsCart.updateView(cart, lineID);

        if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
          Shopify.theme.jsAjaxCart.updateView();
        }
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  },
  updateView: function (cart, lineID) {

    if (cart.item_count > 0) {
      $('[data-ajax-cart-trigger]').addClass('has-cart-count');
      $.ajax({
        dataType: "json",
        async: false,
        cache: false,
        dataType: 'html',
        url: "/cart",
        success: function (html) {

          if (lineID !== null) {

            const updatedItems = $(html).find('.cart__item-list .cart__card');
            const currentItems = $('.cart__item-list .cart__card');

            // Checks if BOGO applied and there is a change in the number of line items
            if (updatedItems.length != currentItems.length){
              const updatedCartList = $(html).find('.cart__item-list');
              // Re-append cart items
              $('.cart__item-list').replaceWith(updatedCartList);
            }

            $(currentItems).each(function(index, element){
              $(element).attr('data-line-item', (index + 1));
              $(element).find('[data-line-item-key]').attr('data-line-item-key', (index + 1));
            })

            const itemTotal = $(html).find(`[data-line-item="${lineID}"]`).find('.cart__total');
            const quantityInput = $(html).find(`[data-line-item="${lineID}"]`).find('.quantity-input');
            const itemPrice = $(html).find(`[data-line-item="${lineID}"]`).find('.cart__price');

            $(`[data-line-item="${lineID}"]`).find('.cart__total').replaceWith(itemTotal);
            $(`[data-line-item="${lineID}"]`).find('.quantity-input').replaceWith(quantityInput);
            $(`[data-line-item="${lineID}"]`).find('.cart__price').replaceWith(itemPrice);

          }

          const subtotal = $(html).find('.cart__footer');

          $('.cart__footer').replaceWith(subtotal);

          $('[data-bind="itemCount"]').text(cart.item_count);

        }
      });

    } else {
      $('.cart__empty-cart-message').removeClass('is-hidden');
      $('.cart__form').addClass('is-hidden');
      $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
      $('[data-bind="itemCount"]').text('0');
    }

    window.removeAllFreeLineItems();

  },
  unload: function ($section) {
    // Clear event listeners in theme editor
    $('[data-cart-page-delete]').off();
    $('#cart_form').off();
  }
}

/******/ })()
;

/* Recharge + cart page sync */
(function ($) {
  'use strict';

  if (window.__themeCartPageRefreshLoaded) return;
  window.__themeCartPageRefreshLoaded = true;

  var refreshTimer = null;
  var refreshRequest = null;

  function getCartPageUrl() {
    if (window.Shopify && Shopify.routes && Shopify.routes.cart_url) {
      return Shopify.routes.cart_url;
    }
    var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    return root.replace(/\/?$/, '/') + 'cart';
  }

  function refreshCartPageNow() {
    var $currentPage = $('.whole_cart_page').first();

    if (!$currentPage.length) return;

    var preservedState = {
      note: $currentPage.find('#note').val(),

      tosChecked: $currentPage.find('#cart_agree').prop('checked'),
      discountInput: $currentPage.find('.discountApplyFormContainer input[type="text"]').first().val()};

    if (refreshRequest && refreshRequest.readyState !== 4) {
      refreshRequest.abort();
    }

    refreshRequest = $.ajax({
      url: getCartPageUrl(),
      type: 'GET',
      dataType: 'html',
      cache: false
    })
      .done(function (html) {
        var parsedHtml = $.parseHTML(
          html,
          document,
          false
        );

        var $parsedPage = $('<div>').append(parsedHtml);
        var $newPage = $parsedPage.find('.whole_cart_page').first();
        if (!$newPage.length) return;
        $('.whole_cart_page').first().replaceWith($newPage);
        var $renderedPage = $('.whole_cart_page').first();

        if (typeof preservedState.note !== 'undefined') {
          $renderedPage.find('#note').val(preservedState.note);
        }

        $renderedPage.find('#cart_agree').prop('checked', Boolean(preservedState.tosChecked));

        if (!window.__clearCartDiscountInput) {
          $renderedPage.find('.discountApplyFormContainer input[type="text"]').first().val(preservedState.discountInput || '');
        }

        window.__clearCartDiscountInput = false;

        if (Shopify.theme && Shopify.theme.currencyConverter) {
          Shopify.theme.currencyConverter.convertCurrencies();
        }

        $(document).trigger('theme:cart-page:refreshed');
      })
      .always(function () {
        refreshRequest = null;
      });
  }

  window.refreshThemeCartPage = function () {
    window.clearTimeout(refreshTimer);

    refreshTimer = window.setTimeout(
      refreshCartPageNow,
      80
    );
  };
})(jQuery);